import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { withFold } from 'bv-hocs';
import { routing as routingSelectors } from 'redux-selectors';

import Expand from './expand';
import LinkItemSingle from './link_item_single';
import LinkItemGroup from './link_item_group';

const { makeIsCurrentPath } = routingSelectors;

export const LinkItem = ({
  children,
  children_links: childrenLinks,
  folded,
  href,
  icon,
  isCurrentPath,
  label,
  small,
  toggleFolded,
}) => {
  const className = classnames('left-component__link-item', {
    active: isCurrentPath,
    'left-component__link-item--small': small,
  });

  const wrapperClassName = classnames('left-component__link-item-wrapper', {
    active: !folded,
  });

  const iconClassName = classnames('left-component__link-icon', {
    'is-active': isCurrentPath,
  });

  const hasChildren = childrenLinks.length > 0;

  return (
    <div className={wrapperClassName}>
      {href
        ? (
          <LinkItemSingle
            href={href}
            icon={icon}
            small={small}
            label={label}
            className={className}
            iconClassName={iconClassName}
          />
        ) : (
          <LinkItemGroup
            className={className}
            hasChildren={hasChildren}
            toggleFolded={toggleFolded}
            icon={icon}
            small={small}
            iconClassName={iconClassName}
            label={label}
          />
        )}
      {hasChildren && (
        <>
          <Expand onClick={toggleFolded} />
          {children}
        </>
      )}
    </div>
  );
};

LinkItem.propTypes = {
  children: PropTypes.element,
  children_links: PropTypes.instanceOf(Array),
  folded: PropTypes.bool.isRequired,
  href: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  isCurrentPath: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  small: PropTypes.bool,
  toggleFolded: PropTypes.func.isRequired,
};

LinkItem.defaultProps = {
  children: null,
  children_links: [],
  small: false,
};

const makeMapStateToProps = () => {
  const isCurrentPath = makeIsCurrentPath();

  return (state, props) => ({
    isCurrentPath: props.href && isCurrentPath(state, props.href),
  });
};

export default connect(makeMapStateToProps)(withFold(LinkItem));
